<div [id]="identifier() + '-description'" class="sr-only">{{ srOnly() }}</div>

<div class="control" [class.invalid]="control().invalid && control().touched">
    @if (label()) {
        <label class="mb-2" [for]="identifier()">{{ label() }}</label>
    }
    <textarea
        [id]="identifier()"
        [attr.data-test]="testId()"
        [formControl]="control()"
        [placeholder]="placeholder() ?? ''"
        [attr.aria-describedby]="control().invalid && control().touched ? identifier() + '-error' : undefined"
        [attr.aria-invalid]="control().invalid && control().touched ? 'true' : undefined"
        [attr.aria-required]="isRequired() ? 'true' : undefined"
        [attr.aria-label]="!label() ? srOnly() : undefined"
        role="textbox"
    ></textarea>
</div>

@if (control().invalid && control().touched) {
    <app-form-error @SlideY [errors]="control().errors" [id]="identifier() + '-error'" />
}
